import { Divider } from "@msuite/ui/divider";
import { FormSwitch, NumberInput, Textarea, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { ArticleGroupFormSchema } from "@msuite/utils/schemas";
import { getArticleGroupNumberString } from "@msuite/utils/stock";
import { Fragment } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useMentionOptions } from "@/hooks/use-mention-options";

export function ArticleGroupForm() {
	/** Context */
	const methods = useFormContext<ArticleGroupFormSchema>();
	const [number, autoGenerateNumber] = useWatch({
		control: methods.control,
		name: ["number", "autoGenerateNumber"],
	});

	/** Hooks */
	const { t } = useTranslation();
	const mentionOptions = useMentionOptions();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<FormSwitch
				control={methods.control}
				name="autoGenerateNumber"
			>
				{t("stock.auto_generate_number")}
			</FormSwitch>
			{!autoGenerateNumber ? (
				<Fragment>
					<NumberInput
						label={t("stock.order_no")}
						isRequired
						control={methods.control}
						name="number"
						placeholder="1"
						variant="integer"
						min={0}
						max={999}
						step={1}
						helperText={getArticleGroupNumberString(number)}
					/>
					<Divider />
				</Fragment>
			) : null}
			<TextInput
				label={t("general.name")}
				name="name"
				isRequired
				control={methods.control}
				placeholder={t("placeholders.stock.article_group_name")}
			/>
			<Textarea
				disableFormatting
				isRequired={false}
				label={t("general.description")}
				control={methods.control}
				name="description"
				{...mentionOptions}
			/>
		</div>
	);
}
